import React from 'react'
import { InputAdornment } from '@mui/material'

import { REQUIRED_PASSWORD_LENGTH } from '../../constants/defaults'
import { RoundedCheck } from '../../icons'
import Text from '../Text'

export interface PasswordAdornmentProps {
  readonly condition?: boolean
  readonly currentLength?: number | null
}

const PasswordAdornment = ({
  condition = false,
  currentLength = 0,
}: PasswordAdornmentProps) => (
  <InputAdornment position="end">
    <Text variant="caption">
      {condition ? (
        <RoundedCheck />
      ) : currentLength ? (
        `${currentLength}/${REQUIRED_PASSWORD_LENGTH}`
      ) : null}
    </Text>
  </InputAdornment>
)

export default PasswordAdornment
